webpackJsonp([200123402633792],{

/***/ 545:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Nick Long's Blog","subtitle":"Engineer & Musician","copyright":"© Nick Long 2018 All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"}],"author":{"name":"Nick Long","email":"#","telegram":"#","twitter":"monquixote","github":"monquixote","rss":"./rss.xml","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/book-review-a-drink-before-the-war-by-dennis-lehane/","categorySlug":"/categories/review/"},"frontmatter":{"title":"Book Review - A Drink Before The War by Dennis Lehane","date":"2011-04-30T00:46:00.000Z","category":"Review","description":null}}}]}},"pathContext":{"tag":"Books"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-books-6acc457762598c8ec705.js